import React, { useState } from "react";
import { ImCross } from "react-icons/im";
import { ReactComponent as Search } from "../../assets/img/svg/SearchIcon.svg";
import { Checkbox, FormControlLabel } from "@mui/material";
import styles from "./styles.module.scss";

const checkBoxStyle = { borderRadius: "6px", padding: "0 5px" };
const formControlLabeStyle = { marginBottom: 0, marginRight: 0 };

const AMultiFieldSearchInput = ({
  options = [],
  searchHandler = () => { },
  crossHandler = () => { },
  isLoading = false,
  displayType = "vertical", // NEW
}) => {
  const [selectedOption, setSelectedOption] = useState(options[0]);
  const [inputVal, setInputVal] = useState("");

  const isValidInput = selectedOption?.isValidInput
    ? selectedOption?.isValidInput(inputVal)
    : true;

  const onKeyDownHandler = (e) => {
    if (e.key === "Enter" || e.keyCode === 13) {
      isValidInput && searchHandler(selectedOption?.keyName, inputVal);
    }
  };

  const handlePaste = (e) => {
    let pastedText = e.clipboardData?.getData("text/plain");
    selectedOption?.regex
      ? selectedOption?.regex?.test(pastedText) && setInputVal(pastedText)
      : setInputVal(pastedText);
    e.preventDefault();
  };

  const checkBoxHandler = (option) => {
    setSelectedOption(option);
    setInputVal("");
  };

  const renderInput = () => (
    <div style={{ position: "relative", flex: 1 }}>
      <input
        value={inputVal}
        onChange={(e) => {
          const value = e.target.value;

          if (selectedOption?.regex) {
            if (!selectedOption.regex.test(value)) return;
            if (value.length > selectedOption.validLength) return;
          }

          setInputVal(value);
          if (value === "") searchHandler(selectedOption?.keyName, "");
        }}
        placeholder={selectedOption?.placeholder}
        style={{ ...(!isValidInput && { borderColor: "#DC2804 !important" }) }}
        className={displayType=="horizontal"?styles["horizontal-searchInput"]: styles["searchInput"]}
        onKeyDown={onKeyDownHandler}
        onPaste={handlePaste}
      />

      {inputVal && (
        <Search
          className={styles["search-icon"]}
          onClick={() =>
            isValidInput && searchHandler(selectedOption?.keyName, inputVal)
          }
        />
      )}

      {inputVal && (
        <ImCross
          className={styles["cross-icon"]}
          onClick={() => {
            crossHandler(selectedOption?.keyName, "");
            setInputVal("");
          }}
        />
      )}
    </div>
  );

  const renderCheckboxes = () =>
    options.length > 1 &&
    options.map((option) => (
      <FormControlLabel
        key={option.keyName}
        sx={formControlLabeStyle}
        control={
          <Checkbox
            onChange={(e) => {
              if (e.target.checked) {
                checkBoxHandler(option);
                inputVal && crossHandler(selectedOption?.keyName, "");
              }
            }}
            checked={selectedOption?.keyName === option?.keyName}
            sx={checkBoxStyle}
          />
        }
        label={<span style={{ fontSize: "12px" }}>{option.label}</span>}
      />
    ));

  return (
    <div
      className={styles["container"]}
      style={{ pointerEvents: isLoading ? "none" : "all" }}
    >
      {displayType === "horizontal" ? (
        <div className="d-flex align-items-center gap-2">
          {/* Checkboxes */}
          <div className={styles["horizontal-options-wrapper"]}>
            {renderCheckboxes()}
          </div>

          {/* Input + error stacked vertically */}
          <div style={{ display: "flex", flexDirection: "column", flex: 1 }}>
            {renderInput()}
            {inputVal && !isValidInput && (
              <div className={styles["errMsg"]}>{selectedOption?.errorMsg}</div>
            )}
          </div>
        </div>
      ) : (
        <>
          {renderInput()}
          {inputVal && !isValidInput && (
            <div className={styles["errMsg"]}>{selectedOption?.errorMsg}</div>
          )}
          {options.length > 1 && (
            <div className={styles["options-wrapper"]}>{renderCheckboxes()}</div>
          )}
        </>
      )}

    </div>
  );

};

export default AMultiFieldSearchInput;
